/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AccountQuoteRequest as ModelsV3LoanManagementAccountQuoteRequest } from '../../models/Models/v3/LoanManagement/account-quote-request';
import { AccountQuoteResponse as ModelsV3LoanManagementAccountQuoteResponse } from '../../models/Models/v3/LoanManagement/account-quote-response';

export interface V3LoanManagementQuotesPost$Xml$Json$Params {
      body?: ModelsV3LoanManagementAccountQuoteRequest
}

export function v3LoanManagementQuotesPost$Xml$Json(http: HttpClient, rootUrl: string, params?: V3LoanManagementQuotesPost$Xml$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3LoanManagementAccountQuoteResponse>> {
  const rb = new RequestBuilder(rootUrl, v3LoanManagementQuotesPost$Xml$Json.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+xml');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsV3LoanManagementAccountQuoteResponse>;
    })
  );
}

v3LoanManagementQuotesPost$Xml$Json.PATH = '/v3/loan-management/quotes';
